import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from '@progress/kendo-react-buttons';
import { CommonResources } from '../../../config/CommonResources';

export interface IEditButtonRowProps {
  visible: boolean;
  onClick: () => void;
}

export function EditButtonRow(props: IEditButtonRowProps): React.ReactElement | null {
  if (!props.visible) return null;
  return (
    <Row>
      <Col className="mt-2 d-flex justify-content-end">
        <Button themeColor="primary" onClick={props.onClick}>
          {CommonResources.Button_Edit}
        </Button>
      </Col>
    </Row>
  );
}

export default EditButtonRow;
